export default {"src":"/_next/static/media/eye-crossed.fe1b1a67.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};